import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text } from 'shared/components'

import RequestForm from './components/requestForm'

import * as styles from './styles'

const DataRemove = ({ onSubmit }) => (
  <Margin resetWhen="phone" css={styles.signupContainer}>
    <section css={styles.signupSection}>
      <Margin as="section" bottom={2}>
        <Text as="h2" size={20} white italic bold>
          Delete your account from InWin app
        </Text>
      </Margin>
      <Margin bottom={2} css={styles.textContainer}>
        <Text italic>What will be deleted?</Text>
        <Text>
          Your account and all associated data which we store remotely on our
          servers.
        </Text>
      </Margin>
      <Margin as="section" tb={2}>
        <RequestForm onSubmit={onSubmit} />
      </Margin>
    </section>
  </Margin>
)

DataRemove.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default DataRemove
